import { render, staticRenderFns } from "./CompanyListLoader.vue?vue&type=template&id=469afe17&"
import script from "./CompanyListLoader.vue?vue&type=script&lang=js&"
export * from "./CompanyListLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports